export const mapTrucksToUi = (data) => {
    const trucks = [];
    if (data) {
        const keys = Object.keys(data);
        keys.forEach((key) => {
            trucks.push({ value: data[key].id, label: data[key].attributes.shortAlias });
        });
    }

    return trucks;
};

export const mapSuppliersToUi = (data) => {
    const suppliers = [];
    if (data) {
        const keys = Object.keys(data);
        keys.forEach((key) => {
            suppliers.push({ value: data[key].id, label: data[key].attributes.name });
        });
    }

    return suppliers;
};

export const mapTruckByIdToUi = (truckData, suppliersData, truckTypeData) => ({
    truckClass: {
        value: truckData?.truckTypeId,
        label: truckTypeData?.attributes.truckClass,
    },
    truckType: {
        value: truckData.truckTypeId,
        label: truckTypeData?.attributes?.shortAlias,
    },
    plateNumber: truckData?.plateNumber,
    year: truckData?.year,
    licenseFace: null,
    licenseBack: null,
    photo: null,
    licenseExpirationDate: truckData?.licenseExpirationDate,
    supplierName: {
        value: truckData?.supplierId,
        label: suppliersData[0]?.attributes?.name,
    },
    suppliers: suppliersData?.map((supplier) => ({
        value: supplier?.id,
        label: supplier?.attributes?.name,
    })),
    notes: truckData.notes,
});
